"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchema = void 0;
const zod_1 = require("zod");
const translation_1 = require("./translation");
const optionalSchema = (schema) => schema.optional();
const createSchemaBuilder = (formatMessage) => ({
    ['boolean']: (options = {}) => {
        const { optional } = options;
        let result = zod_1.z.boolean({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = optional ? optionalSchema(result) : result;
        return result;
    },
    string: (options = {}) => {
        const { optional, email, url, minLength } = options;
        let result = zod_1.z.string({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = email ? result.email() : result;
        result = url ? result.url() : result;
        result = minLength !== undefined ? result.min(minLength) : result;
        result = optional ? optionalSchema(result) : result;
        return result;
    },
    number: (options = {}) => {
        const { optional, rounded, integer, positive, withoutZero } = options;
        let numberResult = zod_1.z.number({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        numberResult = rounded ? numberResult.multipleOf(0.05) : numberResult;
        numberResult = integer ? numberResult.int() : numberResult;
        const getPositive = () => {
            if (positive && withoutZero)
                return numberResult.positive();
            if (positive)
                return numberResult.nonnegative();
            return numberResult;
        };
        let result = getPositive();
        result = optional ? optionalSchema(result) : result;
        return result;
    },
    object: (options = {}) => {
        const { optional, shape } = options;
        let result = zod_1.z.object(shape !== null && shape !== void 0 ? shape : {}, {
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = optional ? optionalSchema(result) : result;
        return result;
    },
    array: (options = {}) => {
        const { optional, shape } = options;
        let result = zod_1.z.array(shape !== null && shape !== void 0 ? shape : zod_1.z.any(), {
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = optional ? optionalSchema(result) : result;
        return result;
    },
});
const createSchema = (create) => ((formatMessage) => create(createSchemaBuilder(formatMessage)));
exports.createSchema = createSchema;
//# sourceMappingURL=schema.js.map